import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { CourseRouteTypeEnum } from "@ryde/shared";

import { StatusIconReplacement } from "../../../../common";

interface ICourseIndicatorIcon {
  routeType: CourseRouteTypeEnum | undefined;
}

export const CourseIndicatorIcon: FC<ICourseIndicatorIcon> = ({
  routeType,
}) => {
  switch (routeType) {
    case CourseRouteTypeEnum.Shuttle:
      return (
        <SVG_MUI.CourseShuttleSVG
          data-e2e="course-indicator-svg-shuttle"
          data-e2e-id="shuttle"
        />
      );
    case CourseRouteTypeEnum.Flex:
      return (
        <SVG_MUI.CourseFlexSVG
          data-e2e="course-indicator-svg-flex"
          data-e2e-id="flex"
        />
      );
    case CourseRouteTypeEnum.Combined:
      return (
        <SVG_MUI.CourseCombinedSVG
          data-e2e="course-indicator-svg-combined"
          data-e2e-id="combined"
        />
      );
    case CourseRouteTypeEnum.JoinConnection:
      return (
        <SVG_MUI.CourseJoinSVG
          data-e2e="course-indicator-svg-join"
          data-e2e-id="join"
        />
      );
    case CourseRouteTypeEnum.SplitConnection:
      return (
        <SVG_MUI.CourseSplitSVG
          data-e2e="course-indicator-svg-split"
          data-e2e-id="split"
        />
      );
    default:
      return <StatusIconReplacement />;
  }
};
